import { render } from "./addModuleGoodsManage.vue?vue&type=template&id=60c51524&scoped=true"
import script from "./addModuleGoodsManage.vue?vue&type=script&lang=js"
export * from "./addModuleGoodsManage.vue?vue&type=script&lang=js"

import "./addModuleGoodsManage.vue?vue&type=style&index=0&id=60c51524&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c51524"]])

export default __exports__